import React, { useEffect, useState } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { authService } from '../../store/services/ServiceAuth'

const PrivateRoute = ({ children }) => {
    const location = useLocation()
    const [isLoading, setIsLoading] = useState(true)
    const [isAuthenticated, setIsAuthenticated] = useState(false)

    useEffect(() => {
        async function checkAuth() {
            const isValid = await authService.validateToken()
            setIsLoading(false)
            setIsAuthenticated(!!isValid)
        }

        checkAuth()
    }, [])

    if (isLoading) {
        return (
            <div className="flex items-center justify-center min-h-screen">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
            </div>
        )
    }

    if (!isAuthenticated) {
        return (
            <Navigate
                to={`/login?next=${encodeURIComponent(location.pathname + location.search)}`}
                replace
                state={{ sessionExpired: true }}
            />
        )
    }

    return children
}

export default PrivateRoute